import React from 'react';
import { ArticleHeading } from './article-heading';
import { Lazy } from 'src/components/lazy';
import { Preamble, StyledArticle } from './styles';
import type { Article as ArticleType } from 'src/types';

export const Article: React.FC<ArticleProps> = ({
  embedded = true,
  ...props
}) => {
  return (
    <StyledArticle>
      {props.imageUrl && (
        <figure>
          <Lazy loadOnIdle>
            <img src={props.imageUrl} alt={props.imageCaption || ''} />
          </Lazy>
          {props.imageCaption && <figcaption>{props.imageCaption}</figcaption>}
        </figure>
      )}
      <ArticleHeading title={props.title} embedded={embedded} />
      {props.preamble && <Preamble>{props.preamble}</Preamble>}
      {props.body && (
        <div
          dangerouslySetInnerHTML={{
            __html: props.body,
          }}
        />
      )}
      {props.byline && <span>{props.byline}</span>}
    </StyledArticle>
  );
};

interface ArticleProps extends Omit<ArticleType, 'id' | 'pathName'> {
  embedded?: boolean;
}
